import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';

import {
  RichTextArticle,
  Attachment,
  Attachments,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

import { contentFolderHasItems } from 'design-comuni-plone-theme/helpers';
import FolderCard from '@package/components/views/Common/FolderCard';

const messages = defineMessages({
  documenti: {
    id: 'documenti',
    defaultMessage: 'Documenti',
  },
  curriculum_vitae: {
    id: 'curriculum_vitae',
    defaultMessage: 'Curriculum vitae',
  },
  atto_nomina: {
    id: 'atto_nomina',
    defaultMessage: 'Atto di nomina',
  },
  dati_economici_retribuzioni: {
    id: 'dati_economici_retribuzioni',
    defaultMessage: 'Dati economici e retribuzioni',
  },
  documentazione_integrativa: {
    id: 'documentazione_integrativa',
    defaultMessage: 'Documentazione integrativa',
  },
  atti_conferimento: {
    id: 'atti_conferimento',
    defaultMessage:
      'Atti di conferimento di incarichi dirigenziali di responsabile dipartimento e di strutture semplici e complesse',
  },
  dichiarazione_insussistenza: {
    id: 'dichiarazione_insussistenza',
    defaultMessage:
      'Dichiarazioni sulla insussistenza cause inconferibilità e incompatibilità',
  },
  dichiarazione_sostitutiva: {
    id: 'dichiarazione_sostitutiva',
    defaultMessage:
      'Dichiarazione sostitutiva di atto di notorietà, relativa alla assunzione di altre cariche presso Enti pubblici o privati e altri eventuali incarichi con oneri a carico della finanza pubblica',
  },
});

const PersonaDocumenti = ({ content }) => {
  const intl = useIntl();
  const location = useLocation();
  const path = location.pathname;

  return (
    <RichTextArticle
      title={intl.formatMessage(messages.documenti)}
      tag_id="documenti"
    >
      <div className="container">
        {(content.curriculum_vitae?.download ||
          contentFolderHasItems(content, 'curriculum-vitae')) && (
          <>
            <div className="row">
              <div className="col-12">
                <h5 className="mb-0">
                  {intl.formatMessage(messages.curriculum_vitae)}
                </h5>
              </div>
            </div>
            <div
              className={cx('row', { 'mb-3': content.atto_nomina.download })}
            >
              {content.curriculum_vitae?.download && (
                <div className="attachment-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
                  <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal">
                    <Attachment
                      download_url={content.curriculum_vitae.download}
                      title={content.curriculum_vitae.filename}
                      item={content.curriculum_vitae}
                    />
                  </div>
                </div>
              )}
              {contentFolderHasItems(content, 'curriculum-vitae') && (
                <div className="attachment-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
                  <Attachments
                    content={content}
                    folder_name={'curriculum-vitae'}
                    as_article={false}
                  />
                </div>
              )}
            </div>
          </>
        )}
        {content.atto_nomina?.download && (
          <div className="row">
            <div className="col-12">
              <h5 className="mb-0">
                {intl.formatMessage(messages.atto_nomina)}
              </h5>
            </div>
            <div className="attachment-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
              <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal">
                <Attachment
                  download_url={content.atto_nomina.download}
                  title={content.atto_nomina.filename}
                />
              </div>
            </div>
          </div>
        )}
        {(contentFolderHasItems(
          content,
          'atti-di-conferimento-incarichi-dirigenziali-responsabile-dipartimento-e-strutture-semplici-e-complesse',
        ) ||
          contentFolderHasItems(
            content,
            'dichiarazioni-sulla-insussistenza-cause-inconferibilita-e-incompatibilita',
          ) ||
          contentFolderHasItems(
            content,
            'dichiarazione-sostitutiva-di-atto-di-notorieta-relativa-alla-assunzione-di-altre-cariche-presso-enti-pubblici-o-privati-e-altri-eventuali-incarichi-con-oneri-a-carico-della-finanza-pubblica',
          )) && (
          <div className="w-100">
            {contentFolderHasItems(
              content,
              'atti-di-conferimento-incarichi-dirigenziali-responsabile-dipartimento-e-strutture-semplici-e-complesse',
            ) && (
              <>
                <div className="row">
                  <div className="col-12">
                    <h5 className="mb-0 mt-2">
                      {intl.formatMessage(messages.atti_conferimento)}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="attachment-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
                    {/* Atti di conferimento di incarichi dirigenziali di responsabile dipartimento e di strutture semplici e complesse */}
                    <Attachments
                      content={content}
                      folder_name={
                        'atti-di-conferimento-incarichi-dirigenziali-responsabile-dipartimento-e-strutture-semplici-e-complesse'
                      }
                      as_article={false}
                    />
                  </div>
                </div>
              </>
            )}
            {contentFolderHasItems(
              content,
              'dichiarazioni-sulla-insussistenza-cause-inconferibilita-e-incompatibilita',
            ) && (
              <>
                <div className="row">
                  <div className="col-12">
                    <h5 className="mb-0 mt-2">
                      {intl.formatMessage(messages.dichiarazione_insussistenza)}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="attachment-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
                    {/* Dichiarazioni sulla insussistenza cause inconferibilità e incompatibilità */}
                    <Attachments
                      content={content}
                      folder_name={
                        'dichiarazioni-sulla-insussistenza-cause-inconferibilita-e-incompatibilita'
                      }
                      as_article={false}
                    />
                  </div>
                </div>
              </>
            )}
            {contentFolderHasItems(
              content,
              'dichiarazione-sostitutiva-di-atto-di-notorieta-relativa-alla-assunzione-di-altre-cariche-presso-enti-pubblici-o-privati-e-altri-eventuali-incarichi-con-oneri-a-carico-della-finanza-pubblica',
            ) && (
              <>
                <div className="row">
                  <div className="col-12">
                    <h5 className="mb-0 mt-2">
                      {intl.formatMessage(messages.dichiarazione_sostitutiva)}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="attachment-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
                    {/* Dichiarazione sostitutiva di atto di notorietà, relativa alla assunzione di altre cariche presso Enti pubblici o privati e altri eventuali incarichi con oneri a carico della finanza pubblica */}
                    <Attachments
                      content={content}
                      folder_name={
                        'dichiarazione-sostitutiva-di-atto-di-notorieta-relativa-alla-assunzione-di-altre-cariche-presso-enti-pubblici-o-privati-e-altri-eventuali-incarichi-con-oneri-a-carico-della-finanza-pubblica'
                      }
                      as_article={false}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {/* Dati economici e retribuzioni */}
        <div className="row mt-3">
          <FolderCard
            url={`${path}/dati-economici-e-retribuzioni`}
            title={intl.formatMessage(messages.dati_economici_retribuzioni)}
          />
        </div>

        {/* Documentazione integrativa */}
        <div className="row">
          <FolderCard
            url={`${path}/documentazione-integrativa`}
            title={intl.formatMessage(messages.documentazione_integrativa)}
          />
        </div>
      </div>
    </RichTextArticle>
  );
};

export default PersonaDocumenti;
